<template>
	<div>
	<el-dialog title="审核" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
		:visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="1200px" height="80%"
		@close="dialogClose" v-el-drag-dialog v-el-dialog-center>
		<template>
			<div id="containt">
				<div style="padding: 5px 8px;">
					<el-tabs v-model="activeName">
						<el-tab-pane label="基本信息" name="first">
							<div class="">
								<el-button type="primary" class="button-sty btn_zdy" @click="showPreconditionDialog = true">

									&lt;&lt;上一单
								</el-button>
								<el-button type="primary" class="button-sty btn_zdy" @click="showPreconditionDialog3 = true">

									执行考核
								</el-button>
								<el-button type="primary" class="button-sty btn_zdy" @click="open">

									取消考核
								</el-button>
								<el-button type="primary" class="button-sty btn_zdy" @click="showPreconditionDialog = true">

									下一单 &gt;&gt;
								</el-button>


							</div>
							<!-- 基本信息 -->
							<div class="d-cont edit-mce-box">
								<div class="d-item">
									<div class="title first"><b>主信息</b></div>
									<table class="table-detail">
										<tbody>
											<tr>
												<th>
													<em class="f-red">*</em>
													考核单号
												</th>
												<td>
													<el-input type="text" autocomplete="off" v-model="formData.userAccount"
														clearable />
												</td>
												<th>
													状态
												</th>
												<td>
													<el-select v-model="formData.siteType2" style="width: 165px;">
														<el-option label="已申诉" :value="1" />
														<el-option label="已申诉" :value="2" />
														<el-option label="已申诉商" :value="3" />
														<el-option label="已申诉" :value="4" />
													</el-select>
												</td>
												<th>网点</th>
												<td>
													<el-input type="text" autocomplete="off" v-model="formData.userShortName"
														clearable> </el-input>
												</td>
												<th>
													<em class="f-red">*</em>
													网点合作状态
												</th>
												<td>
													<el-select v-model="formData.siteType3" style="width: 165px;">
														<el-option label="激活" :value="1" />
														<el-option label="激活" :value="2" />
														<el-option label="激活" :value="3" />
														<el-option label="激活" :value="4" />
													</el-select>
												</td>

											</tr>
											<tr>
												<th>账务组织</th>
												<td>
													<el-input type="text" autocomplete="off" v-model="formData.userAccount3"
														clearable />
												</td>
												<th>
													机构
												</th>
												<td>
													<el-input type="text" autocomplete="off" v-model="formData.address"
														clearable />
												</td>

												<th>
													关联单据
												</th>
												<td>
													<!-- :disabled="true" -->
													<el-input type="text" autocomplete="off" v-model="formData.address"
														clearable />
												</td>

												<th>
													<em class="f-red">*</em>
													区域结算等级
												</th>
												<td>
													<el-select v-model="formData.stat">
														<el-option label="一二级" :value="1" />
														<el-option label="三四级" :value="2" />
														<el-option label="五六级" :value="3" />
													</el-select>
												</td>
											</tr>
											<!-- <tr>
                      <th>备注</th>
                      <td colspan="7">
                        <el-input class="annotate" type="textarea" :rows="2" placeholder="请输入内容" size="small"
                          v-model="formData.faultDescription" clearable></el-input>
                      </td>
                    </tr> -->
											<tr>
												<th>
													<em class="f-red">*</em>
													考核类别
												</th>
												<td>
													<el-select v-model="formData.stat5">
														<el-option label="不满意考核2分" :value="1" />
														<el-option label="不满意考核1分" :value="2" />
														<el-option label="不满意考核3分" :value="3" />
													</el-select>
												</td>
												<th>费用类型</th>
												<td>
													<el-input type="text" autocomplete="off" v-model="formData.userAccount4"
														clearable />
												</td>
												<th>
													考核金额
												</th>
												<td>
													<el-input type="text" autocomplete="off" v-model="formData.address"
														clearable />
												</td>

												<th>
													<em class="f-red">*</em>
													调整金额
												</th>
												<td>
													<!-- :disabled="true" -->
													<el-input type="text" autocomplete="off" v-model="formData.address"
														clearable />
												</td>
											</tr>
											<tr>

												<th>
													合计金额
												</th>
												<td>
													<el-input type="text" autocomplete="off" v-model="formData.address"
														clearable />
												</td>

												<th>
													审批金额
												</th>
												<td>
													<!-- :disabled="true" -->
													<el-input type="text" autocomplete="off" v-model="formData.address"
														clearable />
												</td>

												<th>
													服务属性
												</th>
												<td>
													<el-select v-model="formData.stat">
														<el-option label="安装" :value="1" />
														<el-option label="安装" :value="2" />
														<el-option label="安装" :value="3" />
													</el-select>
												</td>
												<th>品牌</th>
												<td>
													<el-input type="text" autocomplete="off" v-model="formData.userAccount3"
														clearable />
												</td>

											</tr>
											<tr>
												<th>凭证</th>
												<td colspan="">
													<div >
														<el-upload style="display:flex" :class="{ hide_box4: upload_btn4 }"
															:disabled="true" action="/admin/sys-file/upload"
															:on-remove="handleRemove4" list-type="picture-card"
															:file-list="formData.businessPhoto" :on-change="handleSuccess4"
															:limit="3" :auto-upload="false">
															<i slot="default" class="el-icon-plus"></i>
														</el-upload>
													</div>
												</td>
												<!-- <th>凭证2</th>
					  <td colspan="">
                        <div style="width: 165px;">
                            <el-upload style="display:flex" :class="{hide_box4: upload_btn4}"
                              action="/admin/sys-file/upload" :on-remove="handleRemove4" list-type="picture-card"
                              :file-list="formData.businessPhoto" :on-change="handleSuccess4" :limit="3"
                              :auto-upload="false">
                              <i slot="default" class="el-icon-plus"></i>
                            </el-upload>
                          </div>
                      </td>
					  <th>凭证3</th>
					  <td colspan="">
                        <div style="width: 165px;">
                            <el-upload style="display:flex" :class="{hide_box4: upload_btn4}"
                              action="/admin/sys-file/upload" :on-remove="handleRemove4" list-type="picture-card"
                              :file-list="formData.businessPhoto" :on-change="handleSuccess4" :limit="3"
                              :auto-upload="false">
                              <i slot="default" class="el-icon-plus"></i>
                            </el-upload>
                          </div>
                      </td> -->
											</tr>
											<tr>
												<th>网点申诉凭证</th>
												<td colspan="">
													<div style="width: 165px;">
														<el-upload style="display:flex" :class="{ hide_box4: upload_btn4 }"
															:disabled="true" action="/admin/sys-file/upload"
															:on-remove="handleRemove4" list-type="picture-card"
															:file-list="formData.businessPhoto" :on-change="handleSuccess4"
															:limit="3" :auto-upload="false">
															<i slot="default" class="el-icon-plus"></i>
														</el-upload>
													</div>
												</td>
											</tr>
											<tr>
												<th>总部审核凭证</th>
												<td colspan="">
													<div style="width: 165px;">
														<el-upload style="display:flex" :class="{ hide_box4: upload_btn4 }"
															:disabled="true" action="/admin/sys-file/upload"
															:on-remove="handleRemove4" list-type="picture-card"
															:file-list="formData.businessPhoto" :on-change="handleSuccess4"
															:limit="3" :auto-upload="false">
															<i slot="default" class="el-icon-plus"></i>
														</el-upload>
													</div>
												</td>
											</tr>
											<tr>
												<th>考核内容</th>
												<td colspan="7">
													<el-input class="annotate" type="textarea" :rows="1" placeholder="请输入内容"
														size="small" v-model="formData.siteDescription" clearable></el-input>
												</td>
											</tr>
											<tr>
												<th>
													<em class="f-red">*</em>
													申诉人
												</th>
												<el-input type="text" autocomplete="off" v-model="formData.siteManPid"
													clearable />
												<th>
													<em class="f-red">*</em>
													申诉时间
												</th>
												<td>
													<el-date-picker v-model="formData.contractBeginTime" type="date"
														placeholder="选择日期" style="width: 179.33px;">
													</el-date-picker>
												</td>
												<th>申诉内容</th>
												<td colspan="3">
													<el-input class="annotate" type="textarea" :rows="1" placeholder="请输入内容"
														size="small" v-model="formData.siteDescription" clearable></el-input>
												</td>
											</tr>
											<tr>
												<th>
													<em class="f-red">*</em>
													审批人
												</th>
												<el-input type="text" autocomplete="off" v-model="formData.siteManPid"
													clearable />
												<th>
													<em class="f-red">*</em>
													审批时间
												</th>
												<td>
													<el-date-picker v-model="formData.contractBeginTime" type="date"
														placeholder="选择日期" style="width: 179.33px;">
													</el-date-picker>
												</td>
												<th>审批内容</th>
												<td colspan="3">
													<el-input class="annotate" type="textarea" :rows="1" placeholder="请输入内容"
														size="small" v-model="formData.siteDescription" clearable></el-input>
												</td>
											</tr>

											<tr>
												<th>
													<em class="f-red">*</em>
													创建人
												</th>
												<td>{{ formData.createBy }}</td>
												<th>
													<em class="f-red">*</em>
													创建时间
												</th>
												<td>{{ formData.createDate }}</td>
												<th>修改人</th>
												<td>{{ formData.modifyBy }}</td>
												<th>修改时间</th>
												<td>{{ formData.modifyDate }}</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</el-tab-pane>
						<el-tab-pane label="操作记录" name="second">
							<div class="d-cont edit-mce-box">
								<div class="d-item">
									
									<el-table ref="filterTable" border height="535" :data="table_area" class="table_item pic_item"
                  style="width: 95%;"
                  :header-cell-style="{ background: '#F6FAFF',padding: '0',borderTop: '1px solid #eaeaea',fontSize:'12px',color:'#808080'}"
                  :header-row-style="{height:'36px'}" :row-style="{height:'30px',fontSize:'12px', background: '#fff'}">
                  <!-- <el-table-column type="index" width="55">
                  </el-table-column> -->
                  <el-table-column prop="companyId" label="操作类型" width="100">
                  </el-table-column>
                  <el-table-column prop="areaName" label="操作内容" width="250">
                  </el-table-column>
                   <el-table-column prop="areaCode" label="	操作人" width="100">
                  </el-table-column>
                   <el-table-column prop="areaLevel" label="操作时间" width="150">
                  </el-table-column>

                </el-table>
								</div>

							</div>
						</el-tab-pane>

					</el-tabs>
				</div>
			</div>
		</template>
		<span slot="footer" class="dialog-footer">
			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="dialogClose" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
	</el-dialog>
	<preconditionDialog3 v-if="showPreconditionDialog3" 
			:visiable.sync="showPreconditionDialog3" multi="true" />
	</div>
</template>

<script>
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
import { initVxeTable } from '@/const/crud/admin/table'
import preconditionDialog3 from './dialog_1.vue';
import { fetchTree } from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'
import request from "@/router/axios";
export default {
	inject: ['reload'],
	name: 'saleConfigDialog',
	props: ['visiable', 'multi', 'param'],
	mixins: [selectDialogMixins],
	components: { pager,preconditionDialog3 },
	computed: {
    // enabled: {}
    headers: function () {
        const tenantId = store.getters.userInfo.tenantId
        return {
          'Authorization': "Bearer " + store.getters.access_token,
          'TENANT-ID': tenantId ? tenantId : '1'
        };
      }
  },
	created() {
		if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
		this.initSetting();
	},

	watch: {
		filterText(val) {
			this.$refs.tree.filter(val);
		},
		total(newVal, oldVal) {
			this.$refs.pager.tableDataTotal = newVal
		}
	},

	data() {
		return {
			table_area:[],
			upload_btn4: false, // 是否隐藏上传图片按钮
			showPreconditionDialog3: false,
		
			activeName: 'first',
			total: 0,
			filterText: '',
			data: [],
			defaultProps: {
				children: 'children',
				label: 'label',
				id: "id",
				isLeaf: "leaf"
			},
			pageSizes: [10, 20, 100],
			//以上树形
			dataId: 0,
			showEdit: false,
			vxeOption: {},
			isRouterAlive: true,
			// 查询参数
			formData: {
				businessPhoto:[],
				size: 0,
				current: 1,
				searchCount: false,
				brandName: "",
				itemCode: "",
				itemName: "",
				bigCategoryId: '',
				smallCategoryId: '',
			},

			showDialog: true,
			falseValue: false,
			selectMulti: true,
			searchItemName: '',
			searchItemCode: '',
			searchBrandName: '',
			selectedRow: {
				id: '', name: ''
			}
		};
	},


	methods: {
			// 考核备注
			open() {
			this.$prompt('备注[必填]', '是否取消考核', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				//   inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
				//   inputErrorMessage: '邮箱格式不正确'
			}).then(({ value }) => {
				this.$message({
					type: 'success',
					message: '你的添加的考核备注是: ' + value
				});
				// this.reload()// 需要刷新页面
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '取消输入'
				});
				// this.reload()// 需要刷新页面
			});

		},
		handleSuccess4(res, file, fileList) {
  
  // 上传成功后，隐藏上传按钮
  this.upload_btn4 = true;
  console.log(res.data.url,"url")
  this.formData.picList =[
	{url: res.data.url}
  ]

},
handleRemove4(response, file, fileList) {
  // 删除成功后，显示上传按钮
  // this.company.picList=[]
  this.upload_btn4 = false;
  // console.log(this.company.picList,"this.company.picList删除后");
},
		flushed() {
			this.$refs['table-m1'].commitProxy('reload');
		},

		cellClickEvent(e) {
			console.log(e.row.id, '单元格点击事件')
		},


		radioChangeEvent({ row }) {
			this.selectedRow = { id: row.id, name: row.itemName }
		},


		// commitRow() {
		// 		this.$emit('commitSelectedRow', this.selectedRow)
		//   this.dialogClose()
		// 	},


		// 分页功能
		changeTablePage(page, flag) {
			this.formData.size = page.pageSize
			this.formData.current = page.currentPage
			this.formData.searchCount = flag
			this.initTableList();
		},

		filterNode(value, data) {
			if (!value) return true;
			return data.label.indexOf(value) !== -1;
		},

		// 搜索
		searchEvent() {
			this.formData.itemCode = this.searchItemCode
			this.formData.itemName = this.searchItemName
			this.formData.brandName = this.searchBrandName
			this.$refs.pager.clearStoreTableDataTotal()
			this.formData.current = 1
			this.formData.searchCount = false
			this.$refs.pager.reset()  // 重置分页器
			this.flushed()
		},

		// 重置
		resetEvent() {
			this.searchItemCode = ''
			this.searchItemName = ''
			this.searchBrandName = ''
			this.formData.itemCode = ''
			this.formData.itemName = ''
			this.formData.brandName = ''
			this.formData.current = 1
			this.formData.searchCount = false
			this.formData.bigCategoryId = ''
			this.formData.smallCategoryId = ''
			this.$refs.pager.reset()  // 重置分页器
			this.flushed()
			this.reloadTree()
		},


		// 新增
		openEditDialog(id) {
			this.dataId = !id || typeof id == 'object' ? 0 : id;
			this.activeName = 'first';
			this.$openEditView('showEdit');
		},


		reloadTree() {
			this.isRouterAlive = false
			this.$nextTick(function () {
				this.isRouterAlive = true
			})
		},

		// 点击的树形 点
		handleNodeClick(node, data) {
			let id = data.data.id;
			if (data.level === 1) {
				this.formData.bigCategoryId = id;
				this.formData.smallCategoryId = '';
			} else {
				this.formData.smallCategoryId = id;
			}

			this.initTableList();
			this.flushed()
		},

		initTableList() {
			let tableOption = {
				vue: this,
				tableRef: 'table-m1',
				tableName: 'basic_fault_code_list-m1',
				path: '/basic/basItem/getListPage',
				param: this.formData,
				method: 'post',
				columns: [
					{ type: "radio", width: 40, title: '', resizable: false, fixed: 'left' },
					{
						title: '品牌名称',
						field: 'brandName',
						width: 110,
						// fixed: 'left'
					},
					{
						title: '产品编码',
						field: 'itemCode',
						width: 110,
					},
					{
						title: '产品名称',
						field: 'itemName',
						width: 110,
					},
					{
						title: '产品型号',
						field: 'itemModel',
						width: 110,
					},
					{
						title: '产品大类',
						field: 'bigCategoryName',
						width: 110,
					},
					{
						title: '产品小类',
						field: 'smallCategoryName',
						width: 110,
					},
					{
						title: '是否结算',
						field: 'isSettle',
						width: 110,
						slots: {
							default: ({ row }) => {
								if (row.isSettle == 0) {
									return [
										<div class="txt-status disable">
											<span>否</span>
										</div>
									];
								} else if (row.isSettle == 1) {
									return [
										<div class="txt-status">
											<span>是</span>
										</div>
									];
								}
							}
						}
					},
					{
						title: '启用状态',
						field: 'usable',
						width: 110,
						slots: {
							default: ({ row }) => {
								if (row.usable == 0) {
									return [
										<div class="txt-status disable">
											<span>禁用</span>
										</div>
									];
								} else if (row.usable == 1) {
									return [
										<div class="txt-status">
											<span>启用</span>
										</div>
									];
								}
							}
						}
					},


					{
						field: 'createTime',
						title: '创建时间',
						width: 110
					},
					{
						title: '创建人',
						field: 'createBy',
						width: 110,

					},

				]
			};
			this.vxeOption = initVxeTable(tableOption);
			this.flushed()
		},


		// 加载页面
		loadChildNode(node, resolve) {
			fetchTree({
				parentId: node.data.id,
				categoryType: 1
			}).then(({ data }) => {
				console.log(data, "data.data的值"),
					resolve(
						data.data.map(item => {
							return {
								label: item.categoryName,
								id: item.id,
								leaf: Number(item.isChild) == 1 ? false : true,
							}
						})
					)
			});
		},

	}
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
	top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
	top: 0.3em;
}

#containt .grid-height {
	height: 570px;
}

::v-deep .el-dialog {
	// height: 700px;
	overflow: hidden;
}

::v-deep body .dialog-style {
	border-radius: 8px;
	-webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
	box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
	// height: 700px;
	overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
	.el-radio__inner {
		border: 0px;
		background: transparent;
	}

	.el-radio__input.is-checked .el-radio__inner {
		background: none;
	}

	.el-radio {
		height: 100%;
		width: 150px;
		position: absolute;
		z-index: 10;
	}
}

.table_main {
	padding-top: 5px;
	padding-left: 5px;
	border: 1px solid #ededed;
	width: calc(100% - 215px);
	border-bottom: none;

	.el-pagination {
		padding: 2px;

	}
}

.left_tree {
	width: 205px;

	.title {
		text-align: left;
		width: 182px;
		padding: 7px 0 5px !important;
		font-size: 13px;
		color: rgba(58, 39, 39, 0.96);

		>span {
			position: relative;
			left: 4px;
			top: -3px;
		}
	}

	::v-deep.el-tree-node__label {
		width: calc(100% - 32px);
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 12px;
		color: rgba(86, 86, 86, 0.96);
	}
}

.tree_icon {
	background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
	.el-tree-node {
		position: relative;
		padding-left: 0px;
	}

	.el-tree-node__content {
		margin-top: 0px;
	}

	.el-tree-node__children {
		padding-left: 16px;
	}

	.el-tree-node::before {
		content: '';
		height: 100%;
		width: 1px;
		position: absolute;
		left: -3px;
		top: -26px;
		border-width: 1px;
		border-left: 1px dashed #d9d9d9;
	}

	.el-tree-node:last-child::before {
		height: 38px;
	}

	.el-tree-node::after {
		content: '';
		width: 24px;
		height: 1px;
		position: absolute;
		left: -3px;
		top: 12px;
		border-width: 1px;
		border-top: 1px dashed #d9d9d9;
	}

	&>.el-tree-node::after {
		border-top: none;
	}

	&>.el-tree-node::before {
		border-left: none;
	}

	.el-tree-node__expand-icon {
		font-size: 17px;

		// color: #000;
		&.is-leaf {
			color: transparent;
			// display: none;
		}
	}
}

.btn_zdy {
	width: 100px;
    height: 26px;
    border-radius: 15px;
	//   margin: 10px;
	border: 1px solid #dcdfe6 !important;
	border-color: #dcdfe6 !important;
	color: #ffffff !important;
	font-weight: 400;
	text-align: center;
	background-color: #00c4b3 !important;
}

// .btn_zdy:hover {
//   color: #00c4b3 !important;
//   border: 1px solid #00c4b3 !important;
// }
::v-deep .el-button--primary {
	color: #FFF;
	background-color: #00c4b3;
	border-color: #00c4b3;
}

::v-deep.table-detail .el-upload--picture-card {
	// margin-top: 10px;
	width: 40px;
	height: 40px;
	line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
	display: inline-block;
	width: 40px;
	height: 40px;
	margin-right: 14px;
	border-radius: 2px;
	padding: 0 !important;
	border-color: #e8e8e8;
	margin-top: 0;
	margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
	width: 40px;
	height: 40px;
	padding: 0 !important;
	position: inherit;
	cursor: pointer;
}
</style>
